import {fromJS} from 'immutable';
import dashboardActions from '../actions/dashboard.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    loading: false,
    dashboard: {},
    earnings: {},
    profile: {}
});

export const dashboardReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case dashboardActions.TYPES.GET_DASHBOARD_DATA: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case dashboardActions.TYPES.GET_DASHBOARD_DATA_COMPLETE: {
            const {dashboard, earnings, profile} = action.payload;
            newState = fromJS({
                dashboard: dashboard.data,
                earnings: earnings.data,
                profile: profile.data,
                loading: false
            });
            return newState;
        }
        case dashboardActions.TYPES.GET_DASHBOARD_DATA_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case dashboardActions.TYPES.UPDATE_PAYOUT: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case dashboardActions.TYPES.UPDATE_PAYOUT_COMPLETE: {
            const {profile} = action.payload;

            newState = newState.updateIn(['profile'], () => profile.data);
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case dashboardActions.TYPES.UPDATE_PAYOUT_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('dashboard', dashboardReducer);
